import { render, staticRenderFns } from "./DefaultDisplayDetails.vue?vue&type=template&id=2399aaf7&"
import script from "./DefaultDisplayDetails.vue?vue&type=script&lang=js&"
export * from "./DefaultDisplayDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports